import { createContext, useContext, useState } from 'react';

type UserProfile = {
  email: string;
  firstName: string;
  lastName: string;
};

const ProfileContext = createContext<{
  profile: UserProfile | null;
  setProfile: (user: UserProfile) => void;
}>({
  profile: null,
  setProfile: () => {},
});

export const useProfile = () => useContext(ProfileContext);

export default function ProfileProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [profile, setProfile] = useState<UserProfile | null>(null);

  return (
    <ProfileContext.Provider value={{ profile, setProfile }}>
      {children}
    </ProfileContext.Provider>
  );
}
